import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "wijzigingen-aan-tabellen"
    }}>{`Wijzigingen aan tabellen`}</h1>
    <p>{`Hier vind je een volledige lijst van alle wijzigingen aan de Power BI tabellen en velden.`}</p>
    <p>{`Mis je zelf nog een tabel of veld? Laat het ons weten! We horen het graag `}<a parentName="p" {...{
        "href": "https://uurwerk.zendesk.com"
      }}>{`via je helpdesk`}</a>{`.`}</p>
    <h2 {...{
      "id": "11-november-2019"
    }}>{`11 november 2019`}</h2>
    {
      /*tabel [Saldo](/tabellen/saldo) _(nieuw)_<br/>*/
    }
    <p>{`veld `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/medewerker#contracttype-"
      }}>{`Medewerker[ContractType]`}</a>{` `}<em parentName="p">{`(nieuw)`}</em><br />{`
veld `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/medewerker#personeelsnummer-"
      }}>{`Medewerker[Personeelsnummer]`}</a>{` `}<em parentName="p">{`(nieuw)`}</em><br />{`
`}<del parentName="p">{`veld `}<a parentName="del" {...{
          "href": "/powerbi/tabellen/dienst#roostergroepid"
        }}>{`Dienst[RoostergroepID]`}</a></del>{` `}<em parentName="p">{`(verwijderd)`}</em><br /></p>
    <h2 {...{
      "id": "1-oktober-2019"
    }}>{`1 oktober 2019`}</h2>
    <p>{`tabel `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/dienst"
      }}>{`Dienst`}</a>{` `}<em parentName="p">{`(nieuw)`}</em><br />{`
tabel `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/evenement"
      }}>{`Evenement`}</a>{` `}<em parentName="p">{`(nieuw)`}</em><br />{`
tabel `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster"
      }}>{`GepubliceerdRooster`}</a>{` `}<em parentName="p">{`(nieuw)`}</em><br />{`
tabel `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/medewerker"
      }}>{`Medewerker`}</a>{` `}<em parentName="p">{`(nieuw)`}</em><br /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      